var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{class:`checkbox-field ${_vm.checkboxClass}`,attrs:{"id":_vm.id,"name":_vm.id,"button":"","size":_vm.size,"value":true,"unchecked-value":false},on:{"change":_vm.handleCheckboxFieldChange},model:{value:(_vm.checkboxValue),callback:function ($$v) {_vm.checkboxValue=$$v},expression:"checkboxValue"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }